import { useEffect, useRef } from "react";

const CALCULATOR_URL = "/include/calc.html";

function mountCalculatorHtml(shadowRoot, html) {
  const parser = new DOMParser();
  const parsedDoc = parser.parseFromString(html, "text/html");

  parsedDoc.head.querySelectorAll("style").forEach((styleEl) => {
    shadowRoot.appendChild(styleEl.cloneNode(true));
  });

  const contentWrapper = document.createElement("div");
  contentWrapper.innerHTML = parsedDoc.body.innerHTML;

  const scripts = contentWrapper.querySelectorAll("script");
  scripts.forEach((script) => script.remove());

  shadowRoot.appendChild(contentWrapper);

  parsedDoc.body.querySelectorAll("script").forEach((scriptEl) => {
    const runtimeScript = document.createElement("script");
    runtimeScript.textContent = scriptEl.textContent;
    document.body.appendChild(runtimeScript);
    runtimeScript.remove();
  });
}

export default function TrailerMassCalculator() {
  const containerRef = useRef(null);

  useEffect(() => {
    if (!containerRef.current) {
      return;
    }

    const container = containerRef.current;

    const loadCalculatorHtml = async () => {
      const response = await fetch(CALCULATOR_URL);
      if (!response.ok) {
        throw new Error(`Unable to load calculator html: ${response.status}`);
      }

      const remoteHtml = await response.text();
      mountCalculatorHtml(container, remoteHtml);
    };

    loadCalculatorHtml();
  }, []);

  return <div ref={containerRef} style={{ marginTop: "30px" }} />;
}
